import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import TeamComponent from "../components/TeamComponent";
import Partners from "../components/Partners";
import Awards from "../components/Awards";
import Contact from "../components/Contact";

function Team() {
  return (
    <div className="team-bg">
      <Header></Header>
      <TeamComponent></TeamComponent>
      <Contact></Contact>
      <Partners></Partners>
      <Awards></Awards>
      <Footer></Footer>
    </div>
  );
}

export default Team;
